import React, { useState, useEffect } from 'react'
import { Form, Input, Modal, Button, App } from 'antd';
import { useKehuyhzhUpdateSaveMutation, useKehuyhzhDelMutation } from '../../store/DianShangYeWuApi';
function ClientBankEdit(props) {
    const { message, modal } = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        'khyhzh_kh_id': props.kh_id,
        'khyhzh_bank': props.khyhzh_bank,
        'khyhzh_code': props.khyhzh_code,
        'khyhzh_name': props.khyhzh_name,
        'khyhzh_cid': props.yh_id,
        'khyhzh_cname': props.yh_name,
        'khyhzh_content': props.khyhzh_content,
        'khyhzh_id': props.khyhzh_id,
        'khyhzh_update_uname': props.yh_name
    });
    const [form] = Form.useForm();
    useEffect(() => {
        if(open){
            form.setFieldsValue({
                khyhzh_name: props.khyhzh_name,
                khyhzh_bank: props.khyhzh_bank,
                khyhzh_code: props.khyhzh_code,
                khyhzh_content: props.khyhzh_content,
            });
        }
    },[open, props, form]);
    const [updateSave] = useKehuyhzhUpdateSaveMutation();
    const [del] = useKehuyhzhDelMutation();
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.khyhzh_name}</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => {setOpen(false)}} 
                title={props.kh_name}
                footer={[
                    <Button 
                        type='primary' 
                        key='save' 
                        onClick={() => {
                            updateSave(info).then(res => {
                                if(res.data.Status === 'success'){
                                    message.success('修改成功');
                                    setOpen(false);
                                    form.resetFields();
                                }else{
                                    message.error('修改失败'+res.data.Message);
                                }
                            });
                        }}
                    >保存</Button>,
                    <Button 
                        key='cancel' 
                        onClick={() => {
                            modal.confirm({
                                title: '确定删除该账户吗？',
                                content: '删除后不能恢复！',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk: () => {
                                    del({khyhzh_id: props.khyhzh_id}).then(res => {
                                        if(res.data.Status === 'success'){
                                            message.success('删除成功');
                                            setOpen(false);
                                            form.resetFields();
                                        }else{
                                            message.error('删除失败'+res.data.Message);
                                        }
                                    });
                                }
                            }); 
                        }}
                    >删除</Button>,
                ]}
            >
                <Form 
                    form={form} 
                    name={`form_client_bank_edit_${props.khyhzh_id}`} 
                    labelCol={{span: 4}} 
                    wrapperCol={{span: 20}}
                >
                    <Form.Item name='khyhzh_name' label='账户名称' rules={[{ required: true, message: '请输入账户名称' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_name: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_bank' label='开户银行' rules={[{ required: true, message: '请输入开户银行' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_bank: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_code' label='银行账号' rules={[{ required: true, message: '请输入银行账号' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_code: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khyhzh_content' label='备注' >
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khyhzh_content: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item  label='新增记录' >
                        {props.khyhzh_ctime} {props.khyhzh_cname}
                    </Form.Item>
                    <Form.Item  label='修改记录' >
                        {props.khyhzh_update_time} {props.khyhzh_update_uname}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientBankEdit